import type {
  ApiCustomVocabulary,
  CustomVocabulary,
  PostCustomVocabularyBody,
  PatchCustomVocabularyBody,
} from "@app/analytics/types";
import { get, post, patch, httpDelete } from "@app/common/api";
import { parseUTCDateTimeFromString } from "@app/utils/utils";

const parseCustomVocabularyResponse = (
  apiData: ApiCustomVocabulary[]
): CustomVocabulary[] => {
  return (apiData ?? []).map((word) => ({
    ...word,
    createdOn: parseUTCDateTimeFromString(word.createdOn),
  }));
};

export const createCustomVocabulary = async (
  body: PostCustomVocabularyBody
) => {
  return post("/custom-vocabulary", body, { withCreds: true });
};

export const listCustomVocabulary = async () => {
  const response: ApiCustomVocabulary[] = await get("/custom-vocabulary", {
    withCreds: true,
  });
  return parseCustomVocabularyResponse(response);
};

export const patchCustomVocabulary = async (
  body: PatchCustomVocabularyBody
) => {
  return patch(`/custom-vocabulary/${body.id}`, body, { withCreds: true });
};

export const deleteCustomVocabulary = async (id: CustomVocabulary["id"]) => {
  return httpDelete(`/custom-vocabulary/${id}`, { withCreds: true });
};
